/**
 * API-domain error types shared across service and consumers.
 */

/**
 * Thrown when the backend returns 410 Gone, indicating the session record
 * is no longer accessible (24h access window exceeded).
 * Distinct from the frontend inactivity timeout (15 min idle).
 */
export class SessionRecordUnavailableError extends Error {
  constructor() {
    super("Session record is no longer available");
    this.name = "SessionRecordUnavailableError";
  }
}

export class CaptchaVerificationRequiredError extends Error {
  constructor(message = "Friendly Captcha verification required") {
    super(message);
    this.name = "CaptchaVerificationRequiredError";
  }
}
